var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotMe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.86 11.25H16C18.62 11.25 20.75 13.38 20.75 16V18.23L20.6 18.43C18.54 21.18 15.41 22.75 12 22.75C11.75 22.75 11.51 22.73 11.27 22.71C11.62 22.26 11.92 21.77 12.16 21.24C14.95 21.2 17.51 19.93 19.25 17.73V16C19.25 14.21 17.79 12.75 16 12.75H9.51997C8.48997 12.12 7.28997 11.75 5.99997 11.75H5.90997C6.54997 11.44 7.24997 11.25 7.99997 11.25H8.13997C6.97997 10.2 6.24997 8.68 6.24997 7C6.24997 3.83 8.82997 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 8.68 17.02 10.2 15.86 11.25ZM7.74997 7C7.74997 9.34 9.65997 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75C9.65997 2.75 7.74997 4.66 7.74997 7Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 18.5C0.75 15.61 3.1 13.25 6 13.25C8.9 13.25 11.25 15.61 11.25 18.5C11.25 21.39 8.9 23.75 6 23.75C3.1 23.75 0.75 21.39 0.75 18.5ZM8.03 20.53C8.32 20.24 8.32 19.76 8.03 19.47L7.06 18.5L8.03 17.53C8.32 17.24 8.32 16.76 8.03 16.47C7.74 16.18 7.26 16.18 6.97 16.47L6 17.44L5.03 16.47C4.74 16.18 4.26 16.18 3.97 16.47C3.68 16.76 3.68 17.24 3.97 17.53L4.94 18.5L3.97 19.47C3.68 19.76 3.68 20.24 3.97 20.53C4.12 20.68 4.31 20.75 4.5 20.75C4.69 20.75 4.88 20.68 5.03 20.53L6 19.56L6.97 20.53C7.12 20.68 7.31 20.75 7.5 20.75C7.69 20.75 7.88 20.68 8.03 20.53Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotMe);
export default __webpack_public_path__ + "static/media/NotMe.cc16dc41fc8bd37fb607d6986817a1b1.svg";
export { ForwardRef as ReactComponent };